/*@flow*/
import type { ContextT } from './types';
import setIn from 'lib/setIn';
import * as I from 'immutable';

export default function commands(ctx: ContextT): {|
  set: (path: string | Array<any>, value: any) => void,
  setValue: (path: string | Array<any>, value: any) => void,
|} {
  const updateStateValue = (path, value) => {
    commands(ctx).set(['value'].concat(path), value);
  };

  return {
    set(path: string | any[], value: any) {
      ctx.dispatch({
        type: 'SET_RECORD',
        payload: { path, value },
      });
    },
    setValue(path: string | any[], value: any) {
      updateStateValue(path, value);

      // If there is a props.value, do not set the value, and instead
      // call onChange. Otherwise proceed as normal to set the state value.
      if (ctx.state.onChange) {
        const arg = { path, value };
        const v = I.fromJS(ctx.state.value);
        let v2;
        if (I.isImmutable(v)) {
          v2 = setIn(v)(arg);
          if (I.isImmutable(v2)) {
            v2 = v2.toJS();
          }
        } else {
          v2 = value;
        }
        ctx.state.onChange(v2);
      }
    },
  };
}
